var _rect, _path, _path2, _circle;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgPopMenu(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 22,
    height: 15,
    viewBox: "0 0 22 15",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    x: 0.5,
    y: 0.5,
    width: 20.1176,
    height: 14,
    rx: 2.5,
    fill: "white",
    stroke: "#C8C4C4"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M11.7059 7.49996C11.7059 8.13347 11.1923 8.64702 10.5588 8.64702C9.9253 8.64702 9.41174 8.13347 9.41174 7.49996C9.41174 6.86646 9.9253 6.35291 10.5588 6.35291C11.1923 6.35291 11.7059 6.86646 11.7059 7.49996Z",
    fill: "#6A6A6A"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M7.88237 7.49996C7.88237 8.13347 7.36882 8.64702 6.73532 8.64702C6.10181 8.64702 5.58826 8.13347 5.58826 7.49996C5.58826 6.86646 6.10181 6.35291 6.73532 6.35291C7.36882 6.35291 7.88237 6.86646 7.88237 7.49996Z",
    fill: "#6A6A6A"
  })), _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    cx: 14.3824,
    cy: 7.49996,
    r: 1.14706,
    fill: "#6A6A6A"
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgPopMenu);
export default __webpack_public_path__ + "static/media/pop_menu.4a6c67e8d7f70c322710e09db04d01d2.svg";
export { ForwardRef as ReactComponent };